/**
 * Salesforce headers overlap top part of an iFrame with a Titan application embedded as LWC.
 * So, we need to apply some offset to position modals/messages outside overlapped area.
 */
export const SALESFORCE_HEADERS_OFFSET = 158
